import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class SettingsService {
	private key = 'settings'

	load() {
		return JSON.parse(localStorage.getItem(this.key) || '{}');
	}

	save(settings: any): void {
		localStorage.setItem(this.key, JSON.stringify(settings));
	}

	update(partial: Partial<any>): void {
		const current = this.load();
		const updated = { ...current, ...partial };
		this.save(updated);
	}
}
